import { render } from "./UserCheckout.vue?vue&type=template&id=5af1e7f4&scoped=true"
import script from "./UserCheckout.vue?vue&type=script&lang=js"
export * from "./UserCheckout.vue?vue&type=script&lang=js"

import "./UserCheckout.vue?vue&type=style&index=0&id=5af1e7f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af1e7f4"]])

export default __exports__